module.exports = __webpack_public_path__ + "static/media/undertalepacifist.d3c81c43.jpg";